import React from 'react'

export default function PostMessage({message}) {
  return (
    <div className="post_bottom">
            <p>{message}</p>
    </div>
  )
}
